/* 
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */


app.controller('dialog_updatePasswordCtrl', ['$rootScope', '$scope', '$http', 'NetworkService', 'MainService', 'Notification', function ($rootScope, $scope, $http, NetworkService, MainService, Notification) {

        $scope.success = function (msg) {
            Notification.success(msg);
        };
        $scope.error = function (msg) {
            Notification.error(msg);
        };
        $scope.updatePassword = function ()
        {
            if ($scope.newPasswordRepeat == $scope.newPassword)
            {
                var data = {old_password: $scope.oldPassword,
                    new_password: $scope.newPassword}

                NetworkService.updatePassword(data, function (data) {
                    if(data.done)
                    {
                        $scope.success("Das Passwort wurde geänder")
                    }
                    else
                    {
                        $scope.error("Das Passwort war nicht richtig")
                    }
                })
            } else
            {
                $scope.error("Die Passwörter stimmen nicht überein")
            }

        }


    }])